module.exports = __webpack_public_path__ + "static/media/simba.0e6ae129.png";